import dayjs from 'dayjs';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { Coordinates } from '../coordinates.model';
import { VerifMateriel } from '../verif-materiel.model';
import { UserEvent } from './user-event.model';

export class DebutVacationInterPonctuelle extends UserEvent {
  public static NAME = 'DEBUT_INTER_PONCTUELLE_EVENT';
  constructor(
    public idCreneau: string,
    public idVacation: string,
    public debut: dayjs.Dayjs,
    public verificationMateriel?: VerifMateriel,
    public champsPersonnalises: ChampCompteRendu[] = [],
    public idConsignes: string[] = [],
    coordinates?: Coordinates
  ) {
    super(DebutVacationInterPonctuelle.NAME, undefined, coordinates);
  }

  public static hydrate(obj: DebutVacationInterPonctuelle): DebutVacationInterPonctuelle {
    return new DebutVacationInterPonctuelle(
      obj.idCreneau,
      obj.idVacation,
      dayjs(obj.debut),
      obj.verificationMateriel,
      obj.champsPersonnalises,
      obj.idConsignes,
      obj.coordinates
    );
  }
}
